
import { Component, inject } from '@angular/core'

import { Store } from '@ngrx/store'

import { FlxButtonModule } from '@flowx/angular-ui-toolkit'
import { ConversationActions } from '@flowx/designer/modules/ai/conversation/conversation.actions'
import { ConversationSelectors } from '@flowx/designer/modules/ai/conversation/conversation.selectors'
import { selectProcessResourceId } from '@flowx/designer/shared/store/selectors/router.selectors'

@Component({
  selector: 'flx-context-header',
  templateUrl: './context-header.component.html',
  styleUrls: ['./context-header.component.scss'],
  imports: [FlxButtonModule],
})
export class ContextHeaderComponent {
  #store = inject(Store)
  selectedDocument = this.#store.selectSignal(ConversationSelectors.selectedDocument)
  selectedProcessResourceId = this.#store.selectSignal(selectProcessResourceId)
  newDocumentsCount = this.#store.selectSignal(ConversationSelectors.newDocumentsCount)
  isLoading = this.#store.selectSignal(ConversationSelectors.loading)

  openContextDocuments(): void {
    this.#store.dispatch(ConversationActions.documentContextOpened({}))
  }
}
